import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class AuthenticatedPlayQueueController extends Controller {
  @service betaFeatures;
}
